"use strict";

exports.__esModule = true;
var _LiveTimelineQueryController = require("./LiveTimelineQueryController");
Object.keys(_LiveTimelineQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LiveTimelineQueryController[key]) return;
  exports[key] = _LiveTimelineQueryController[key];
});